﻿'use strict';

/**
 * @ngdoc directive
 * @name ntmApp.directive:complexFilterControl
 * @description
 * # complexFilterControl
 */
angular.module('ntmApp')
  .directive('complexFilterControl', [function () {
      return {
          restrict: 'E',
          templateUrl: 'ng1/src/reports/complexFilterControl/complexFilter.html',
          scope: {
              searchCriteria: '='
          },
          link: function (scope) {
             
              scope.OpeningParenthesis = '(';
              scope.ClosingParenthesis = ')';
              scope.ConditionalOperators = ['AND', 'OR'];
          }
      };
  }]);